// Module
var code = "<oc-form name=\"vm.form\"> <amt-content> <amt-row> <div class=\"support-text\" ng-bind-html=\"vm.supportText\"></div> </amt-row> </amt-content> </oc-form>";
// Exports
module.exports = code;